import { setActiveTab } from '../State/activeTab';

export default (activeTab) => async (dispatch) => {

  dispatch(setActiveTab(activeTab));

}